{
  "GenericScopeTab_CME": "FMC",
  "GenericScopeTab_Telsys": "Serveur de téléphonie",
  "GenericScopeTab_Telsys_Required": "Un serveur de téléphonie est requis",
  "GenericScopeTab_Partition": "Partition",
  "GenericScopeTab_Device": "Appareil",
  "GenericScopeTab_FilterRecursive": "Filtrer récursivement",
  "NAME": "GenericScopeTab"
}